import React, { useState, useEffect } from "react";
import Section from "./layouts/Section";
import { WebLink, SiteWide } from "./customComponents";
import { CopyToClipboard } from 'react-copy-to-clipboard';
import Helper1, { notify, niceDate, money } from '../utility/Helper1';
import { mainStyle, mainColor, header, otherColors } from '../utility/styles';
import CustomAgo from "./customComponents/CustomAgo";

import { useSelector, useDispatch } from 'react-redux';
import { authActions, withdrawalActions } from '../redux/actions';
import { userSelect, allRemoteSettingsSelect, homeScreenStatSelect } from '../redux/selectors/index';
import LoadingOverlay from 'react-loading-overlay';
import { Images } from "./customComponents";

import { RiMore2Fill } from "react-icons/ri";

import {
    Menu,
    MenuItem,
    MenuButton
} from '@szhsin/react-menu';
import '@szhsin/react-menu/dist/index.css';
import '@szhsin/react-menu/dist/transitions/slide.css';

function TeamEarning() {
    const [loadingText, setLoadingText] = useState('Loading network...');
    const [loading, setLoading] = useState(false)
    const [dataForLevel1, setLevel1] = useState([])
    const [dataForLevel2, setLevel2] = useState([])
    const [dataForLevel3, setLevel3] = useState([])
    const [viewingForLevel1, setViewingForLevel1] = useState(0)
    const [viewingForLevel2, setViewingForLevel2] = useState(0)
    const [viewingForLevel3, setViewingForLevel3] = useState(0)
    const [viewingLevel, setViewingLevel] = useState(1)
    const [focusedTopMenu, setFocusedTopMenu] = useState(1)
    const [showDropdown, setShowDropdown] = useState(false)

    const [refData, setRefData] = useState([])
    const site_settings = useSelector(allRemoteSettingsSelect);
    const finance = useSelector(homeScreenStatSelect);

    const dispatch = useDispatch();

    const loadDownLines = (myrefid, level) => {

        setLoading(true)

        dispatch(authActions.onRefreshSystemData(`user/referral/${myrefid}`, 10, {}, response => {


            setLoading(false)

            setRefData(response?.data?.referrals)

        }))
    }

    useEffect(() => {
        loadDownLines(userData?.myrefid, 1);
    }, [])

    const processRefWithdrawal = () => {


        setLoading(true);
        setLoadingText('Receiving...');

        dispatch(authActions.onLogin(`withdraw/ref`, { currency: finance?.[0]?.type }, response => {
            notify(response.msg, response.code)
            if (response.code == 1) {

            }
            setLoading(false);
        }))
    }

    const userData = useSelector(userSelect);

    const getValueForMenu = (eachdownline, menuId, autoConfirm) => {
        const suffix = autoConfirm;
        switch (menuId) {
            case 1: return eachdownline[`profitToday${suffix}`];
            case 2: return eachdownline[`totalDeposit${suffix}`];
            case 3: return eachdownline[`totalWithdrawal${suffix}`];
            default: return '$0';
        }
    };

    const currentData = refData[`level${viewingLevel}`] || [];

    // Loading Overlay
    if (loading) {
        return (
            <div className="fixed inset-0 bg-black bg-opacity-80 backdrop-blur-sm flex items-center justify-center z-50">
                <div className="text-center">
                    <div className="inline-block animate-spin rounded-full h-16 w-16 border-t-2 border-b-2 border-cyan-400 shadow-lg shadow-cyan-400/50"></div>
                    <p className="text-cyan-300 mt-4 text-lg font-semibold">{loadingText}</p>
                    <div className="mt-2 w-64 bg-gray-700 rounded-full h-1">
                        <div className="bg-gradient-to-r from-cyan-400 to-purple-500 h-1 rounded-full animate-pulse" style={{ width: '60%' }}></div>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <SiteWide id="main" title={`Affiliate Center`}>
            <Section loading={loading} overlayText={loadingText} title={'Affiliate Center'}>

             
                <div className="relative z-10 container mx-auto px-4 py-8">
                    {/* Header Section with Level Selection */}
                    <div className="mb-8 text-center">
                        <h1 className="text-4xl font-bold bg-gradient-to-r from-cyan-400 via-purple-500 to-pink-500 bg-clip-text text-transparent mb-3 animate-pulse">
                            ⚡ Team Earnings Dashboard
                        </h1>
                        <p className="text-gray-300 text-lg mb-6">Monitor your team's performance across all levels</p>
                        
                        {/* Compact Level Selection */}
                        <div className="inline-flex items-center bg-slate-900/80 backdrop-blur-xl border border-slate-700/50 rounded-2xl p-2 shadow-2xl shadow-purple-500/10">
                            {[1, 2, 3].map((level) => {
                                const memberCount = refData[`level${level}`]?.length || 0;
                                const isActive = viewingLevel === level;
                                return (
                                    <button
                                        key={level}
                                        onClick={() => setViewingLevel(level)}
                                        className={`relative group overflow-hidden rounded-xl px-6 py-3 mx-1 transition-all duration-300 transform ${
                                            isActive
                                                ? 'bg-gradient-to-r from-cyan-500 to-purple-600 text-white shadow-lg shadow-cyan-500/30 scale-105 z-10'
                                                : 'text-gray-300 hover:text-white hover:bg-slate-700/50 hover:scale-102'
                                        }`}
                                    >
                                        <div className="flex items-center space-x-2 relative z-10">
                                            <span className="text-sm font-bold">Level {level}</span>
                                        </div>
                                        {isActive && (
                                            <div className="absolute inset-0 bg-gradient-to-r from-cyan-400/20 to-purple-600/20 animate-pulse rounded-xl"></div>
                                        )}
                                        {/* Hover effect */}
                                        {!isActive && (
                                            <div className="absolute inset-0 bg-gradient-to-r from-cyan-500/0 to-purple-600/0 group-hover:from-cyan-500/10 group-hover:to-purple-600/10 transition-all duration-300 rounded-xl"></div>
                                        )}
                                    </button>
                                );
                            })}
                        </div>
                    </div>

                    {/* Data Table */}
                    <div className="bg-slate-900/60 backdrop-blur-xl border border-slate-700 rounded-2xl overflow-hidden shadow-2xl">
                        <div className="border-b border-slate-700 p-6">
                            <div className="flex items-center justify-between">
                                <div className="flex items-center">
                                    <div className="w-12 h-12 rounded-xl bg-gradient-to-r from-purple-500 to-pink-500 flex items-center justify-center text-white text-xl mr-4 shadow-lg">
                                        👀
                                    </div>
                                    <div>
                                        <h3 className="text-xl font-bold text-white">
                                            Level {viewingLevel} Team Members
                                        </h3>
                                        <p className="text-gray-400 text-sm">
                                            {currentData.length} active members in your network
                                        </p>
                                    </div>
                                </div>
                                <div className="flex items-center space-x-3">
                                    <span className="px-4 py-2 bg-gradient-to-r from-cyan-500/20 to-purple-500/20 text-cyan-400 rounded-xl text-sm border border-cyan-500/30 shadow-lg">
                                        {currentData.length} active
                                    </span>
                                </div>
                            </div>
                        </div>

                        {currentData.length > 0 ? (
                            <div className="overflow-x-auto">
                                <table className="w-full">
                                    <thead>
                                        <tr className="border-b border-slate-700 bg-slate-800/30">
                                            <th className="text-left py-4 px-6 text-cyan-400 font-semibold">
                                                <div className="flex items-center">
                                                    <span className="mr-2">👤</span>
                                                    Username
                                                </div>
                                            </th>
                                            <th className="text-right py-4 px-6 text-cyan-400 font-semibold">
                                                <div className="flex items-center justify-end">
                                                    <span className="mr-2">💰</span>
                                                    Earnings
                                                </div>
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {currentData.map((member, index) => (
                                            <tr
                                                key={index}
                                                className="border-b border-slate-800/50 hover:bg-slate-800/30 transition-all duration-200 group"
                                            >
                                                <td className="py-4 px-6">
                                                    <div className="flex items-center">
                                                        <div className="w-12 h-12 rounded-xl bg-gradient-to-r from-purple-500 to-pink-500 flex items-center justify-center text-white font-bold mr-4 group-hover:scale-110 transition-transform duration-200 shadow-lg">
                                                            {member.username.charAt(0).toUpperCase()}
                                                        </div>
                                                        <div>
                                                            <div className="text-white font-medium text-lg">{member.username}</div>
                                                            <div className="text-gray-400 text-sm flex items-center">
                                                                <span className="w-2 h-2 bg-green-400 rounded-full mr-2 animate-pulse"></span>
                                                                Active member
                                                            </div>
                                                        </div>
                                                    </div>
                                                </td>
                                                <td className="py-4 px-6 text-right">
                                                    <div className="flex items-center justify-end space-x-3">
                                                        {finance.filter(item => item.autoConfirm === 0).map((item, idx) => (
                                                            <div key={`0-${idx}`} className="flex flex-col items-end">
                                                                <span className="inline-block px-4 py-2 bg-gradient-to-r from-blue-500 to-purple-600 text-white text-sm font-medium rounded-xl shadow-lg">
                                                                    {getValueForMenu(member, focusedTopMenu, 0)}
                                                                </span>
                                                                <span className="text-xs text-gray-400 mt-1">{item.type}</span>
                                                            </div>
                                                        ))}
                                                        <div className="text-gray-500 text-xl">|</div>
                                                        {finance.filter(item => item.autoConfirm === 1).map((item, idx) => (
                                                            <div key={`1-${idx}`} className="flex flex-col items-end">
                                                                <span className="inline-block px-4 py-2 bg-gradient-to-r from-green-500 to-teal-600 text-white text-sm font-medium rounded-xl shadow-lg">
                                                                    {getValueForMenu(member, focusedTopMenu, 1)}
                                                                </span>
                                                                <span className="text-xs text-gray-400 mt-1">{item.type}</span>
                                                            </div>
                                                        ))}
                                                    </div>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        ) : (
                            <div className="text-center py-20">
                                <div className="text-8xl mb-6 opacity-60">👥</div>
                                <h3 className="text-2xl font-bold text-gray-300 mb-3">
                                    No team members in Level {viewingLevel}
                                </h3>
                                <p className="text-gray-500 mb-8 text-lg">
                                    Start building your network to see earnings data
                                </p>
                                <div className="flex justify-center">
                                    <div className="w-32 h-1 bg-gradient-to-r from-cyan-400 via-purple-500 to-pink-500 rounded-full shadow-lg"></div>
                                </div>
                            </div>
                        )}
                    </div>
                </div>

            </Section>
        </SiteWide>
    );
}

export default TeamEarning;